export interface IRecentActivityItem {
  type: "event" | "course" | "club";
  id: string;
  name: string;
  link: string;
  logo_url?: string;
}

export namespace localStorageService {
  //
  export const ACCESS_TOKEN = "access_token";
  export const USER = "user";
  export const DOWNLOADS = "downloads";
  export const CAPACITIES = "capacities";
  export const CLUB = "club";
  export const RECENT_ACTIVITY = "recent_activity";

  export const setItem = (item: string, value: string) => {
    localStorage.setItem(item, value);
  };

  export const getItem = (item: string): string | null => {
    return localStorage.getItem(item);
  };

  export const removeItem = (key: string) => {
    localStorage.removeItem(key);
  };

  export const getRecentActivity = (): IRecentActivityItem[] => {
    const raw = localStorage.getItem(RECENT_ACTIVITY);
    if (!raw) return [];
    try {
      return JSON.parse(raw) as IRecentActivityItem[];
    } catch {
      return [];
    }
  };

  export const addRecentActivity = (item: IRecentActivityItem): void => {
    const current = getRecentActivity();
    // Deduplicate by id, push newest to front, cap at 5
    const updated = [item, ...current.filter(i => i.id !== item.id)].slice(0, 5);
    localStorage.setItem(RECENT_ACTIVITY, JSON.stringify(updated));
  };
}
